import { Button, FontIcon, MovieDetails } from '@intigral/shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { appConfig } from '../../config/app.config';
import { ButtonTypes, CACHE_CONFIG_TYPES, COMPONENT_TYPES } from '../../config/constants';
import h from '../../helpers/common';
import f from '../../helpers/formatter';
import AddWatchlistButton from './AddWatchlistButton';
import LockIcon from './LockIcon';
import PlayVideoButton from './PlayVideoButton';
import { IStore } from '../../interfaces/StoreTypes';
import { Program } from '@intigral/ui';
import { ILocalStorageConfigurationObject } from '../../types/ILocalStorage';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import usePPVManagement from '../../hooks/usePPVManagement';
import { useConfiguration } from '../../hooks/useConfiguration';

interface WatchListRewindItemProps {
    item: any;
    onRemove: () => void;
    componentType: string;
    componentName: string;
    id: string;
}

const WatchListRewindItem: React.FC<WatchListRewindItemProps> = ({ item, onRemove, componentType, componentName }) => {
    // Use PPV management hook for all PPV-related functionality
    const { shouldShowLock } = usePPVManagement();

    const channelId = item?.channelId || item?.channelID || item?.id || item?.channelNo || item?.channelNumber;
    const { isLocked, enhancedChannel } = shouldShowLock(item, channelId);
    const { data: newConfig } = useConfiguration();
    return (
        <div className="masonry-item" id="eps-card">
            <Program
                program={{
                    duration: '',
                    name: '',
                    showProgress: false,
                    progress: 0,
                    channelImage: null,
                    channelTitle: item.channelName,
                    isReminderSet: false,
                    poster: h.getImagizerUrl(
                        item.image ? item.image : item.images?.find((img) => img.type === 'cover')?.url,
                        newConfig?.imagizer?.components_images.WATCHLIST_REWIND_ITEM
                    ),
                    showPlay: false,
                    text: item.text,
                    badge: isLocked ? <LockIcon corner /> : undefined,
                }}
                assetDetails={{
                    info: [
                        item.channelName,
                        item.ratings && typeof item.ratings === 'string' ? item.ratings.toUpperCase() : null,
                        Array.isArray(item.genre) ? item.genre : [],
                        item.startTime && item.endTime
                            ? `${f.formatRewindDate(item.startTime, true)} - ${f.formatRewindDate(item.endTime, false)}`
                            : undefined,
                        item.year ? `${item.year}` : null,
                    ],
                }}
                type="rewind"
                CTAs={[
                    !isLocked ? (
                        <PlayVideoButton
                            buttonType={ButtonTypes.RewindItem}
                            item={item}
                            componentType={componentType}
                            componentName={componentName}
                        >
                            <Button primary social compact>
                                <FontIcon name="play" size="smaller" md="smaller" />
                            </Button>
                        </PlayVideoButton>
                    ) : (
                        <LockIcon inline />
                    ),
                    <AddWatchlistButton
                        item={item}
                        type={ButtonTypes.VodeItem}
                        componentType={COMPONENT_TYPES.REWIND_CAROUSEL}
                        // componentName={name}
                    />,
                ]}
                noHeight
            />
            {/* <div className="poster-container">
                <div className="img-link">
                    <img
                        src={h.getImagizerUrl(
                            item.image ? item.image : item.images?.find((img) => img.type === 'cover')?.url,
                            appConfig.components_images.WATCHLIST_REWIND_ITEM
                        )}
                    />
                </div>
                {!isLocked && (
                    <div className="over-poster">
                        <PlayVideoButton
                            buttonType={ButtonTypes.RewindItem}
                            item={item}
                            componentType={componentType}
                            componentName={componentName}
                        >
                            <span className="play-icon" />
                        </PlayVideoButton>
                    </div>
                )}
                {isLocked && <LockIcon filled />}
                <AddWatchlistButton
                    item={item}
                    // type={ButtonTypes.RewindItem}
                    onRemove={onRemove}
                    componentType={componentType}
                    componentName={componentName}
                />
            </div>
            <div className="eps-poster-detail">
                <div className="eps-poster-detail-text">
                    <h6>{item.text}</h6>
                    <p>{item.channelName}</p>
                    <MovieDetails
                        info={[
                            ...(Array.isArray(item.genre) ? item.genre : []), // Ensure item.genre is an array
                            item.startTime && item.endTime
                                ? `${f.formatRewindDate(item.startTime, true)} - ${f.formatRewindDate(
                                      item.endTime,
                                      false
                                  )}`
                                : undefined,
                        ].filter(Boolean)} // Filter out any undefined values
                    />
                </div>
            </div> */}
        </div>
    );
};
export default WatchListRewindItem;
